"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ResultsMapView;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ResultsMapView(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "View_manipulation",
    "data-name": "View manipulation"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "results-map-view"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline",
    d: "M82.786,45.945H63.961a4.5,4.5,0,0,1-4.5-4.5V12a4.5,4.5,0,0,1,4.5-4.5H82.786a4.505,4.505,0,0,1,4.5,4.5V41.445A4.5,4.5,0,0,1,82.786,45.945Zm-18.325-5H82.286V12.5H64.461ZM82.786,92.5H63.961a4.5,4.5,0,0,1-4.5-4.5V58.555a4.5,4.5,0,0,1,4.5-4.5H82.786a4.5,4.5,0,0,1,4.5,4.5V88A4.505,4.505,0,0,1,82.786,92.5Zm-18.325-5H82.286V59.055H64.461ZM32.482,78.416a3.824,3.824,0,0,1-2.71-1.121,2.472,2.472,0,0,1-.424-.566L15.3,51.1c-.108-.188-.234-.415-.354-.648l-.152-.276a2.535,2.535,0,0,1-.178-.407,19.545,19.545,0,0,1-1.9-8.418,19.769,19.769,0,1,1,39.537,0A19.557,19.557,0,0,1,50.337,49.8a2.273,2.273,0,0,1-.164.377L50,50.5c-.094.184-.22.411-.349.638L35.618,76.729a2.5,2.5,0,0,1-.425.566A3.823,3.823,0,0,1,32.482,78.416ZM19.315,48.028l.04.073c.116.22.209.389.306.557L32.482,72.046,45.283,48.7c.118-.207.212-.376.3-.548l.065-.118c.026-.067.055-.135.087-.2a14.617,14.617,0,0,0,1.515-6.479,14.769,14.769,0,1,0-29.537,0,14.617,14.617,0,0,0,1.515,6.479A2.118,2.118,0,0,1,19.315,48.028Zm28.666.949h0ZM32.483,35.51A6.285,6.285,0,1,0,38.768,41.8,6.285,6.285,0,0,0,32.483,35.51Z"
  }))));
}